import React from 'react';
import axios from 'axios';
import Promise from 'bluebird';


import {component, Component, classnames, makePath} from '../component';
import Dropzone from '../Dropzone';
import TopBanner from '../TopBanner';
import Games from '../Games';
import DataEditButton from '../DataEditButton';
import Flag from '../Flag';
import ProfileStats from '../ProfileStats';
import {Skype, CancelSmall, Warning, CheckedSmall} from '../icons';
import {HBox, VBox} from '../Box';
import TournamentAnnouncement from '../TournamentAnnouncement';
import Avatar from '../Avatar';
import {TableListRow, TableListCell} from '../TableList';
import ActionButton from '../ActionButton';
import EditField from '../EditField';
import LoadMoreButton from '../LoadMoreButton';
import Api from '../../api';
import Link from '../Link';

import {teamCheckActiveTournament} from './../teamCheckActiveTournament';
import notices from './../notices';

import teamApplicationStatuses from './../teamApplicationStatuses';


function rankImageUrl(rank) {
  rank = rank + 1;
  if (rank < 10) {
    rank = `.${rank}`;
  }
  try {
    return require(`../../img/ranks/${rank}.jpg`);
  } catch(err) {
    return require('../../img/ranks/.1.jpg');
  }
}

const UserTeam = component('UserTeam', function({data, userTeam, isOwner, isCaptain}) {
  return (
    <div className='PlayerDetails-TeamContainer'>
      {
        isOwner ?
          <TeamControls data={data} isCaptain={isCaptain} userTeam={userTeam} hasTeam={userTeam.deref()} />
          :
          <div>
            <div className='PlayerDetails-TeamLabel'>Команда</div>
            <Link name='teamDetails' params={{id: userTeam.get('id')}} className='PlayerDetails-TeamName'>
              {userTeam.get('title')}
            </Link>
          </div>
      }
    </div>
  )
});

const TeamControls = component('TeamControls', function({data, hasTeam, userTeam, isCaptain}) {

  function leaveTeam() {
    const team = data.get('team');
    if( team && teamCheckActiveTournament(team, data.cursor('popup')) ){
      if( isCaptain && data.getIn(['team', 'member_count']) > 1 ) {
        data.cursor('popup').set({
          icon: Warning,
          message: notices.captainCanNotLeaveTeam,
          action: 'Ок',
          iconWidth: 128,
          autoClose: true,
          iconHeight: 128
        });
        return;
      }



      data.cursor('popup').set({
        icon: Warning,
        message: notices.approveLeaveTeam,
        action: 'Покинуть команду',
        iconWidth: 128,
        iconHeight: 128,
        onAction: async function () {
          try {
            await Api.leaveTeam();
            data.cursor(['teamData', userTeam.get('id')]).set(null);
            data.cursor(['user', 'has_team']).set(false);
            data.cursor(['userData', data.getIn(['user', 'id']), 'has_team']).set(false);
            data.cursor(['userData', data.getIn(['user', 'id']), 'team']).set(null);
            data.cursor(['userData', data.getIn(['user', 'id']), 'member_role']).set(null);
            data.cursor(['popup', 'close']).set(true);
          } catch (r) {}
        }
      });
    }
  }

  return hasTeam
    ?
    <div>
      <div className='PlayerDetails-TeamLabel'>Команда</div>
      <Link name='teamDetails' params={{id: userTeam.get('id')}} className='PlayerDetails-TeamName'>
        {userTeam.get('title')}
      </Link>
      <DataEditButton text='покинуть команду' onClick={leaveTeam} />
    </div>
    :
    <div>
      <Link name='teams' query={{sort: 'member_count'}}>
        <DataEditButton text='найти команду' onClick={() => undefined} />
      </Link>
      <Link name='teamsNew'>
        <DataEditButton text='создать команду' onClick={() => undefined} />
      </Link>
    </div>;
});


const TeamLogo = component('TeamLogo', function({team}) {
  const teamAvatar = team.get('image') || require('../../img/teamEmptyAvatar.png');

  return (
    <div className='PlayerDetails-TeamLogoContainer' style={{
      backgroundImage: `url(${teamAvatar})`
    }} />
  )

});

export default class PlayerDetails extends Component {

  constructor(props) {
    super(props);
    this.state = this.getUpdatedState(props);
  }

  getUpdatedState = (props) => {
    const data = props.data;
    const params = props.params;

    const currentUser = data.cursor('user');
    const isCaptain = currentUser.get('member_role') === 1;
    const userId = parseInt(params.id, 10);
    const user = data.cursor(['userData', userId]);
    const userTeam = data.cursor(['userData', userId, 'team']);

    const isOwner = userId === data.cursor('user').getIn('id');

    const justAcceptedInvite = data.cursor('invites').hasData()
        ? data.getIn('invites').find((invite) => invite.get('status') === teamApplicationStatuses['accepted'].id)
        : undefined;

    return {
      userId, isOwner, currentUser, user, userTeam, justAcceptedInvite, isCaptain
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getUpdatedState(nextProps))
  }

  componentWillMount() {
    if (this.state.isOwner) {
      this.loadInvites();
    }
  }

  loadInvites = async () => {
    let response = await Api.invites();
    this.props.data.cursor('invites').set(response.data);
  };


  invitePlayer = async () => {
    const team = this.props.data.get('team');
    if( team && teamCheckActiveTournament(team, this.props.data.cursor('popup'))) {
      this.state.user.setIn('invite_sent', true);
      await Api.userInvite(this.props.params);
    }
  };

  invitePlayerCancel = async function() {
    this.state.user.setIn('invite_sent', false);
    await Api.userInviteCancel({id: this.state.userId});
  };

  async inviteAccept(inviteId, team) {
    if(team && teamCheckActiveTournament(team, this.props.data.cursor('popup'))) {
      try {
        await Api.invitesAccept({inviteId});
        this.props.data.cursor(['userData', this.props.data.cursor('user').getIn('id')]).setIn(['team'], team);
        this.props.data.cursor('user').setIn('has_team', true);
        this.props.data.cursor('invites').forEach((invite) =>
          inviteId === invite.get('id') ? invite.setIn('status', teamApplicationStatuses['accepted'].id) : '');
      } catch (e) {
        this.props.data.cursor('popup').set({
          icon: Warning,
          message: notices.couldNotAcceptInvite,
          action: 'Понятно',
          iconWidth: 128,
          iconHeight: 128,
          autoClose: true
        })
      }
    }
  }

  async inviteReject(inviteId) {
    this.props.data.cursor('invites').forEach(invite =>
        inviteId === invite.get('id') ? invite.setIn('status', teamApplicationStatuses['rejected'].id) : '');
    await Api.invitesReject({inviteId});
  }

  async loadMoreGames() {
    this.props.data.setIn(['userGames', this.state.userId, 'loading'], true);
    await Api.userGames(this.props.data, this.props.params, this.props.query);
    this.props.data.setIn(['userGames', this.state.userId, 'loading'], false);
  }

  async loadMoreTournaments() {
    this.props.data.setIn(['userTournaments', this.state.userId, 'loading'], true);
    await Api.userTournaments(this.props.data, this.props.params, this.props.query);
    this.props.data.setIn(['userTournaments', this.state.userId, 'loading'], false);
  }

  async updateBio() {
    let {data} = await Api.userUpdate({
      id: this.state.currentUser.get('id'),
      bio: this.state.currentUser.get('bio')
    });
    this.state.currentUser.set(data);
  }

  renderLoaded({data}, {userId, isOwner, currentUser, user, userTeam, justAcceptedInvite, isCaptain}) {
    return (
      <div className='PlayerDetails'>
        <TopBanner size='regular'>
          <div className='PlayerDetails-TeamAvatar'>
            <div className='PlayerDetails-Left'>
              {
                userTeam.deref() !== undefined &&
                <div>
                  {isOwner ?
                      <div className='PlayerDetails-Team'>
                        {
                          userTeam.deref()
                            ?
                            <Link name='teamDetails' params={{id: userTeam.get('id')}}>
                              <TeamLogo team={userTeam} />
                            </Link>
                            :
                            <TeamLogo team={userTeam} />
                        }
                        <UserTeam isOwner={isOwner} isCaptain={isCaptain} userTeam={userTeam} data={data} />
                      </div>
                      :
                      <div>
                        {
                          userTeam.deref()
                          ?
                            <div className='PlayerDetails-Team'>
                              <Link name='teamDetails' params={{id: userTeam.get('id')}}>
                                <TeamLogo team={userTeam} />
                              </Link>
                              <div className='PlayerDetails-TeamContainer'>
                                <div className='PlayerDetails-TeamLabel'>Команда</div>
                                <Link name='teamDetails' params={{id: userTeam.get('id')}} className='PlayerDetails-TeamName'>
                                      {userTeam.get('title')}
                                </Link>
                              </div>
                            </div>
                          :
                            <div>
                            {
                              isCaptain
                              &&
                              <div className='PlayerDetails-Team'>
                                <TeamLogo team={userTeam} />
                                <div className='PlayerDetails-TeamContainer'>
                                    {
                                      this.state.user.getIn('invite_sent')
                                      ?
                                      <div>
                                        <div className="PlayerDetails-TeamContainerCaption PlayerDetails-InvitationSent">Приглашение отправлено</div>
                                        <DataEditButton onClick={this.invitePlayerCancel.bind(this)} text='отменить прилашение' />
                                      </div>
                                      :
                                      <DataEditButton onClick={this.invitePlayer.bind(this)} text='пригласить в команду' />
                                    }
                                </div>
                              </div>
                              }
                            </div>
                        }
                      </div>
                  }
                </div>
              }
            </div>
            <div className='PlayerDetails-Middle'>
              {isOwner
                ? <Avatar type='User' popup={data.cursor('popup')} isOwner={isOwner} data={currentUser} league={userTeam.get('league')} leagueClassName="League--playerAvatar" />
                : <Avatar type='User' popup={data.cursor('popup')} isOwner={isOwner} data={user} league={userTeam.get('league')} leagueClassName="League--playerAvatar" />
              }
            </div>
            <div className='PlayerDetails-Right'>

            </div>
          </div>
          <h2 className='PlayerDetails-About'>
            {isOwner
                ?
                <EditField
                    updateMethod={this.updateBio.bind(this)}
                    valueKey='bio'
                    defaultValue="Добавить статус"
                    data={currentUser}
                    />
                :
                <div>{user.get('bio')}</div>
            }
          </h2>
          {user.get('pointblank_nickname') &&
          <div className='PlayerDetails-Rank'>
            <img className='PlayerDetails-RankImage'
                 src={rankImageUrl(user.get('pointblank_level') || 0)}/>
            <div>
              {user.get('pointblank_nickname')}
            </div>
          </div>
          }
          {!user.get('pointblank_nickname') &&
          <div className='PlayerDetails-Rank'></div>
          }
          <ProfileStats data={user} className='PlayerDetails-Stats' />
        </TopBanner>

        {((isOwner && data.getIn('invites') && data.getIn('invites').size && !currentUser.get('has_team')) || justAcceptedInvite) &&
        <HBox width={4}>
          <h3 className='PlayerDetails-ApplicationTeamHeader'>Приглашения в команду</h3>
          {data.getIn('invites').map((invite) => {
            const itemImage = invite.getIn(['team', 'image']);
            const bgImage = itemImage
                ? itemImage + '?crop=1&w=88&h=88'
                : require('../../img/teamEmptyAvatarSquare.png');
            return <TableListRow height={88} bordered key={invite.get('id')} grayedOut={justAcceptedInvite && justAcceptedInvite.get('id') !== invite.get('id')}>
              <TableListCell width={88} type='Logo' >
                <Link name='teamDetails' className="TableListCell-Avatar"  params={{id: invite.getIn(['team', 'id'])}} style={{
                      backgroundImage: `url(${bgImage})`,
                      width: 88,
                      height: 88
                    }} />
              </TableListCell>
              <TableListCell width={648} type='Primary'>
                <div className='PlayerDetails-ApplicationTeamTitle'>
                  <Link name='teamDetails' params={{id: invite.getIn(['team', 'id'])}}>
                    {invite.getIn(['team', 'title'])}
                  </Link>
                </div>
                <div className='PlayerDetails-ApplicationTeamCountry'>
                  <Flag country={invite.getIn(['team', 'country'])} outputName />
                </div>
              </TableListCell>

              {invite.get('status') !== teamApplicationStatuses['new'].id
                  ?
                  <TableListCell width={440} type='Action'>
                    <div className='TableListCell-ItemState'>
                      <div className='TableListCell-ItemStateStatus'>
                        {invite.get('status') === teamApplicationStatuses['accepted'].id && <CheckedSmall className='TableListCell-IconChecked' />}
                        {invite.get('status') === teamApplicationStatuses['rejected'].id && <CancelSmall className='TableListCell-IconChecked' />}
                      </div>
                      <div>
                        {invite.get('status') === teamApplicationStatuses['accepted'].id && 'Приглашение принято!'}
                        {invite.get('status') === teamApplicationStatuses['rejected'].id && 'Приглашение отклонено'}
                      </div>
                    </div>
                  </TableListCell>
                  :
                  <TableListCell width={440} type='Action'>
                    <ActionButton text='Принять' arrow className='PlayerDetails-ButtonAccept'
                                  onClick={!justAcceptedInvite && this.inviteAccept.bind(this, invite.getIn(['id']), invite.getIn(['team']))} />
                    <ActionButton icon={<CancelSmall />} className='PlayerDetails-ButtonReject'
                                  onClick={!justAcceptedInvite && this.inviteReject.bind(this, invite.getIn(['id']))} />
                  </TableListCell>
              }

            </TableListRow>
          })}
        </HBox>
        }

        <HBox width={4}>
          <VBox width={2} isContainer>
            {data.cursor(['userGames', userId, 'list']).hasData()
                ? <Games type="vertical" data={data.cursor(['userGames', userId, 'list'])} />
                : <div className="PlayerDetails-EmptyBlock">
              матчи не сыграны
            </div>
            }
          </VBox>
          <VBox isContainer width={2}>
            {data.cursor(['userTournaments', userId, 'list']).hasData()
                ? data.cursor(['userTournaments', userId, 'list']).map((tournament, idx) =>
                <TournamentAnnouncement picPosition="left" description details key={idx}
                                        isListItem data={tournament} />)
                : <div className="PlayerDetails-EmptyBlock">
              турниры не сыграны
            </div>
            }
          </VBox>
        </HBox>

        <HBox width={4}>
          <VBox width={2} isContainer>
            {!data.getIn(['userGames', userId, 'noMore']) &&
            <LoadMoreButton text="игр" onClick={this.loadMoreGames.bind(this)}
                            loading={data.getIn(['userGames', userId, 'loading'])} />
            }
          </VBox>
          <VBox width={2} isContainer>
            {!data.getIn(['userTournaments', userId, 'noMore']) &&
            <LoadMoreButton text="турниров" onClick={this.loadMoreTournaments.bind(this)}
                            loading={data.getIn(['userTournaments', userId, 'loading'])} />
            }
          </VBox>
        </HBox>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/PlayerDetails.js